module.exports = __webpack_public_path__ + "img/last-badge-pitch.72b8dfff.svg";